function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNsgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  },
  viewBox: "0 0 5867 5867",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4663.85 5474.57H253.53V2249.38h719.33v448.107H701.638v2334.88h3514.1v-2334.88h-2346.67V2249.38h2794.77v3225.19Zm949.279-1857.29h-725.226v-448.107h277.119V840.193h-3520v2328.98h2352.56v448.107h-2800.67V392.09h4416.21v3225.19Z",
  style: {
    fillRule: "nonzero"
  }
}));
export default SvgNsgLink;